module.exports = __webpack_public_path__ + "img/logo-eu.145979ba.png";